<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h3 id="header-text" class="align-self-end pb-1">Archived Vehicle Portfolio Report</h3>
  <div class="d-flex gap-8 pb-1 align-items-center">
    <button mat-flat-button color="primary" id="run-report-button" class="action-button"
            (click)="getArchivedPorfolioReport()"
            [disabled]="!selectedArchive">
      Run Report
    </button>
  </div>
</div>

<div class="d-flex flex-row gap-8">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label class="asterisk--before">Archived Portfolios</mat-label>
    <mat-select [(ngModel)]="selectedArchive" id="archived-portfolio-select">
      <mat-option *ngFor="let name of archiveList" [value]="name">
        {{ name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
